var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8635 21.9771H24.75V23.8635H4V21.9771H5.88647V5.94264C5.88647 5.69264 5.98579 5.45287 6.16256 5.27609C6.33934 5.09931 6.57911 5 6.82911 5H21.9197C22.1697 5 22.4095 5.09931 22.5862 5.27609C22.763 5.45287 22.8623 5.69264 22.8623 5.94264L22.8635 21.9771ZM10.6021 13.4885V15.375H13.4312V13.4885H10.6021ZM10.6021 9.71558V11.6021H13.4312V9.71558H10.6021ZM10.6021 17.2603V19.1468H13.4312V17.2615L10.6021 17.2603ZM15.3176 17.2603V19.1468H18.1468V17.2615L15.3176 17.2603ZM15.3176 13.4873V15.3738H18.1468V13.4885L15.3176 13.4873ZM15.3176 9.71439V11.6021H18.1468V9.71558L15.3176 9.71439Z",
    fill: "#6D57DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.c558e391fb54d01d42ed29c8955cd04c.svg";
export { ForwardRef as ReactComponent };